import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../auth/auth-guard.service";
import { AdminConsolidationsComponent } from "./admin-consolidations/admin-consolidations.component";
import { AdminPackageReceivedComponent } from "./admin-package-received/admin-package-received.component";
import { AdminPanelComponent } from "./admin-panel/admin-panel.component";
import { AdminShipmentsComponent } from "./admin-shipments/admin-shipments.component";
import { DailyDistributionComponent } from "./reporting/daily-distribution/daily-distribution.component";
import { DailyStatisticComponent } from "./reporting/daily/daily.component";
import { TrackCheckComponent } from "./clients/track-check/track-check.component";
import { TrackDeliveryComponent } from "./clients/track-delivery/track-delivery.component";
import { ClientsDashboardComponent } from "./clients/clients-dashboard/clients-dasboard.component";

const appRoutes: Routes = [
    {
        path: 'adminPanel',
        component: AdminPanelComponent,
        canActivate: [AuthGuard],
        data: { userRole: ['admin', 'storeman'] },
        children:
            [
                {
                    path: 'consolidations',
                    canActivate: [AuthGuard],
                    data: { userRole: ['admin', 'storeman'] },
                    component: AdminConsolidationsComponent
                },
                {
                    path: 'shipments',
                    canActivate: [AuthGuard],
                    data: { userRole: ['admin'] },
                    component: AdminShipmentsComponent
                },
                {
                    path: 'received',
                    component: AdminPackageReceivedComponent
                },
                {
                    path: 'clients',
                    children: [
                        { path: '', component: TrackCheckComponent },
                        { path: 'delivery', component: TrackDeliveryComponent },
                        { path: 'clientData', canActivate: [AuthGuard], data: { userRole: ['admin'] }, component: ClientsDashboardComponent },
                    ]
                },
                {
                    path: 'reporting',
                    canActivate: [AuthGuard],
                    data: { userRole: ['admin'] },
                    children: [
                        { path: '', canActivate: [AuthGuard], data: { userRole: ['admin'] }, component: DailyStatisticComponent },
                        { path: 'distribution', canActivate: [AuthGuard], data: { userRole: ['admin'] }, component: DailyDistributionComponent }
                    ]
                },
            ]
    },
]

@NgModule({
    imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
    exports: [RouterModule]
})
export class AdminPanelRoutingModule { };